import React from "react";
import Ellipse from "images/icons/ellipse.inline.svg";

const CourseModules = ({ moduleData }) => {
  return (
    <div className="px-4 md:px-7 py-9 text-white planet:text-gray-generic">
      {moduleData?.map((module, index) => (
        <div
          key={index}
          className={`relative flex gap-4 md:gap-7 items-start md:items-center
                      before:absolute before:w-[2px] before:bottom-0 before:left-[3px] before:bg-white before:planet:bg-[#888888]
                      ${index === 0 ? "before:top-3" : "before:top-0"} 
                      ${
                        index === moduleData.length - 1
                          ? "pb-0 before:h-2"
                          : "pb-8"
                      }`}
        >
          <Ellipse className="shrink-0 fill-white planet:fill-gray-generic w-2 h-2 mt-2 md:mt-0" />
          <div dangerouslySetInnerHTML={{ __html: module.moduleName }} />
        </div>
      ))}
    </div>
  );
};

export default CourseModules;
